import { render, staticRenderFns } from "./ViewIcon.vue?vue&type=template&id=74f83c3d&"
import script from "./ViewIcon.vue?vue&type=script&lang=ts&"
export * from "./ViewIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports